import * as React from 'react';

var _path, _g, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgAddPayment = function SvgAddPayment(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 80 80"
    }, props), /*#__PURE__*/ React.createElement("mask", {
        id: "mask0_87_25036",
        width: 80,
        height: 80,
        x: 0,
        y: 0,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "alpha"
        }
    }, _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#D9D9D9",
        d: "M0 0h80v80H0z"
    }))), _g || (_g = /*#__PURE__*/ React.createElement("g", {
        mask: "url(#mask0_87_25036)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_87_25036)",
        fillOpacity: 0.16,
        d: "M14 25.5a5 5 0 0 1 5-5h50a5 5 0 0 1 5 5v37a5 5 0 0 1-5 5H19a5 5 0 0 1-5-5z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint1_linear_87_25036)",
        d: "M14.615 63.333q-1.854 0-3.234-1.38T10 58.718V21.282q0-1.854 1.38-3.235 1.382-1.38 3.235-1.38h50.77q1.854 0 3.234 1.38T70 21.282V36.52H12.564v22.327q0 .898.577 1.41.577.513 1.474.513h27.289q.545 0 .913.374.369.374.369.926 0 .553-.369.909-.368.355-.913.355zm-2.05-33.974h54.87v-8.077q0-.897-.576-1.474-.577-.577-1.474-.577h-50.77q-.898 0-1.474.577-.577.577-.577 1.474zm54.468 42.308q-.551 0-.908-.369a1.26 1.26 0 0 1-.356-.913v-8.718h-8.718q-.544 0-.913-.374a1.27 1.27 0 0 1-.369-.926q0-.553.369-.909.369-.355.913-.355h8.718v-8.718q0-.545.374-.914.374-.368.926-.368.553 0 .909.368.355.369.355.914v8.718h8.718q.546 0 .914.373.368.374.368.927 0 .552-.368.908t-.914.356h-8.718v8.718q0 .544-.373.913-.374.369-.927.369"
    }))), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_87_25036",
        x1: 14.627,
        x2: 73.165,
        y1: 44,
        y2: 44,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_87_25036",
        x1: 10.713,
        x2: 77.382,
        y1: 44.166,
        y2: 44.166,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })))));
};

export { SvgAddPayment as ReactComponent };
//# sourceMappingURL=AddPayment.svg.es.js.map
